// src/Testimonials.js
import React from "react";
import "./clientTestimonial.styles.css";
import ClientTestimonialCard from "../cards/clientTestimonialCard/clientTestimonialCard.component";
import clientTestimonies from "../../data/clientTestimony";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ClientTestimonials = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 968,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div id="clients-testimonials" className="client-testimonial-container">
      <div className="client-testimonial-wrap">
        <div className="client-section-header">
          <h2 className="home-heading">clients Testimonials</h2>
        </div>
        <div className="testimonials-wrapper">
          <Slider {...settings}>
            {clientTestimonies.map((testimony, index) => (
              <ClientTestimonialCard
                key={index}
                testimony={testimony.testimony}
                fullName={testimony.fullName}
                position={testimony.position}
                logo={testimony.logo}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ClientTestimonials;
